import { Col, Row, Input, Button } from 'antd';
import queryString from 'query-string';
import React, { useEffect, useState} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GetLocalStorageValue } from '../../../../_config/adapters/local-storage/get-local-storage-value.adapter';
import CustomCard from '../../../../v2-components/Antd/Card';
import CustomLink from '../../../../v2-components/Antd/Link';
import CustomPagination from '../../../../v2-components/Antd/Pagination';
import LoadingPage from '../../../../v2-components/LoadingPage';
// import { formatedDate } from './handle/formated-date.handle';
import { Service } from './service';
import './style.scss';
import Images from '../../../../components/Commons/Images';
import { default as trackingIcon } from '../../../../components/Commons/Assets/Icons/Filled/Enabled/tracking.svg';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { GlobalConsumer } from '../../../../components/Commons/Context/Global';
import { UnixToDate } from './handle/unix-to-date.handle';

export default function ProfileMagistralFormulaPage() {
	const history = useHistory();
	const location = useLocation();
	const [isLoading, setIsLoading] = useState(true);
	const [magistralQuotation, setMagistralQuotation] = useState();
	const [pagination, setPagination] = useState();
	const [searchId, setSearchId] = useState('');
	const email = GetLocalStorageValue('userEmail');
	const { isMobile } = GlobalConsumer();

	const { Search } = Input;

	useEffect(() => {
		const params = queryString.parse(location.search);
		const page = params.page || 1;
		const payload = {
			page: page,
			country: Enviroment.COUNTRY,
			pharmacy: Enviroment.ROOT_PHARMACY,
			user_email: email		
		}
		new Service()
			.getMagistralQuotation(payload)
			.then((response) => {
				setMagistralQuotation(response.data);	  		
				setPagination(response);
				setIsLoading(false);
			})
			.catch((error) => {
				console.log(error);
			});
	}, [location.search, email]);

	console.log("magistralQuotation", pagination);
	console.log("magistralQuotations", magistralQuotation);

	const handlePageChange = (page) => {
		window.scrollTo(0, 0);
		const queryParams = { page };
		history.push({ search: queryString.stringify(queryParams) });
		console.log("page", page);
	};

	if (isLoading) {
		return <LoadingPage />;
	}

	const onSearch = (value) => {
		setSearchId(value.trim());
	};

	const filteredQuotations = searchId 
	? magistralQuotation.filter((item) => item.short_code.toString().includes(searchId))
	: magistralQuotation;
 	
if (magistralQuotation.length === 0) {
    return (
        <>
            <div className="history-header">
                <h2 className="history-title">Historial de cotizaciones</h2>
                <Button type="link" className="back-to-account-link">
                    Volver a mi cuenta
                </Button>
            </div>
            
            <div className="empty-state-container">
                <div className="empty-state-card">
                    <div className="empty-state-icon">
				<Images classContent={'ph-search-tracking-image-container'} classImage={'ph-search-tracking-image'} default={trackingIcon} title={'rastreo'} />
                    </div>
                    
                    <p className="empty-state-message">
                        Aún no hay solicitudes realizadas por ti.
                    </p>
                    
                    <Button 
                        type="primary" 
                        size="large" 
                        className="go-to-start-btn"
                        onClick={() => {
                            history.push('/');
                        }}
                    >
                        Ir al inicio
                    </Button>
                </div>
            </div>
        </>
    );
}

	return (
		<>
			<Row justify="center">
				<Col md={24} xs={22}>
					<Row justify="left">
						<h2 style={{marginTop: '20px', marginBottom: '0px', fontSize: '18px'}}>Historial de cotizaciones</h2>
					</Row>
					<Row justify="space-between" align="bottom">
						<CustomLink style={{marginTop: '0px'}} className={'link-primary'} to="/profile-info">
							Volver a mi cuenta
						</CustomLink>
						<Search
							placeholder="N° de solicitud"
							allowClear
							style={{ width: 180 }}
							onSearch={onSearch}
						/>
					</Row>
					<br></br>
				<Row>

				{isMobile && (
					<Col xs={24} md={10}>
						<Col>
							<div className="empty-state-container" style={{ marginBottom: '20px' }}>
								<div className="empty-state-card">
									<div className="empty-state-icon">
								<Images classContent={'ph-search-tracking-image-container'} classImage={'ph-search-tracking-image'} default={trackingIcon} title={'rastreo'} />
									</div>
									
									<p className="empty-state-message">
										El número de solicitud se envía por mail al momento de realizar la gestión.
									</p>
									
								</div>
							</div>

						</Col>
						
					</Col>
					)}

					<Col md={14}>
						{filteredQuotations?.map((item, index) => {
							
							return (
								<React.Fragment key={`card-${index}`}>
									<Col key={`card-${index}`}>
										<CustomCard
											onClick={() => {
												history.push(`/profile-info/magistral-formula/${item.id}/${item.short_code}/${pagination?.current_page}`);
											}}
											title={`Solicitud N°: ${item?.short_code} - Cotización de receta`}
											className={'card-primary pointer'}
											extra={<p>{item.status_tracking.status_description}</p>}
										>
											<Row justify="space-between" className={'card-row'}>
												{/*<Col md={8} xs={24}>*/}
												<Col>
													<span className={'data'}>Farmacia: </span>{item.pharmacy}
												</Col>
												<Col>
													<p className={'date'}>{UnixToDate(item.created_at)}</p>
												</Col>
											</Row>

											<Row justify="left" className={'card-row'}>
												<Col xs={24}>
													<span className={'data'}>Nombre: </span>{item.user_info.first_name + ' ' + item.user_info.last_name}
												</Col>
											</Row>

										</CustomCard>
										<br></br>
									</Col>
								</React.Fragment>
							);
						})}
					</Col>
				{!isMobile && (
					<Col xs={24} md={10}>
						<Col>
							<div className="empty-state-container" style={{ marginLeft: '15px', marginBottom: '20px' }}>
								<div className="empty-state-card">
									<div className="empty-state-icon">
								<Images classContent={'ph-search-tracking-image-container'} classImage={'ph-search-tracking-image'} default={trackingIcon} title={'rastreo'} />
									</div>
									
									<p className="empty-state-message">
										El número de solicitud se envía por mail al momento de realizar la gestión.
									</p>
									
								</div>
							</div>

						</Col>
						
					</Col>
				)}

				</Row>
			
					<Row justify="center" align="middle" className={'custom-pagination'} style={{ flexDirection: 'column' }}>
						<Row justify="center" style={{ width: '100%' }}>
							<CustomPagination
								className={'pagination-default'}
								current={pagination?.current_page}
								total={pagination?.total_items}
								pageSize={pagination?.items_per_page}
								onChange={handlePageChange} />
						</Row>
						<Row justify="start" style={{ width: '100%'}}>
							<span className="ph-elastic-right-side-paging-info-title">
								Mostrando:{' '}
								<strong className="ph-elastic-right-side-paging-info-subtitle">
									{pagination?.begin_page} - {pagination?.end_page}
								</strong>{' '}
								de un Total:{' '}
								<strong className="ph-elastic-right-side-paging-info-subtitle">
									{pagination?.total_items}
								</strong>
							</span>
						</Row>
					</Row>
				</Col>
			</Row>
		</>
	);
}
